
/**
* cardsList.directives Module
*
* Description
*/
var app = angular.module('directives.printReceipt', []);

	require('./directives/receipt.directive.js');
	require('./stylesheet/style.scss');

module.exports = app;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/printReceipt/index.js
 ** module id = 211
 ** module chunks = 1
 **/